import React from "react";

function ArrowDown({ width, height, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      stroke={color}
      viewBox="0 0 15 14"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g>
        <path
          fill="none"
          d="M7.50002 1.16675V12.8334M7.50002 12.8334L13.3334 7.00008M7.50002 12.8334L1.66669 7.00008"
        ></path>
      </g>
    </svg>
  );
}

export default ArrowDown;
